import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-functionalities',
  templateUrl: './functionalities.component.html',
  styleUrls: ['./functionalities.component.css']
})
export class FunctionalitiesComponent implements OnInit {

  mobile:boolean=false;
  medium:boolean=false;
  constructor() { }

  ngOnInit(): void {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    if (window.screen.width <= 768) { // 768px portrait
      this.mobile = true;
    }else {
      this.mobile = false;
    }
    if ($(".main-menu__nav").length && $(".mobile-nav__container").length) {
      let navContent = document.querySelector(".main-menu__nav")!.innerHTML;
      let mobileNavContainer = document.querySelector(
        ".mobile-nav__container"
      );
      mobileNavContainer!.innerHTML = navContent;
    }
    $(".mobile-nav__toggler").on("click", function (e) {
      e.preventDefault();
      $(".mobile-nav__wrapper").toggleClass("expanded");
      $("body").toggleClass("locked");
    });

    // ✅ Ferme le menu mobile sur tout clic de lien de navigation
    setTimeout(() => {
      $('.link_menu').on('click', function() {
        $('.fa-times').trigger('click');
      });
    }, 800);

    // ✅ Scroll vers la section cible après navigation inter-pages
    const scrollTarget = sessionStorage.getItem('scrollTarget');
    if (scrollTarget) {
      sessionStorage.removeItem('scrollTarget');
      setTimeout(() => {
        this.smoothScroll(scrollTarget);
      }, 800);
    }
  }

  
  smoothScroll(sectionId: string): void {
    setTimeout(() => {
      const $target = $('#' + sectionId);
      if ($target.length) {
        $('html, body').animate({
          scrollTop: $target.offset()!.top - 70
        }, 600);
      }
      // if(!this.mobile){
      //   $('.fa-times').trigger('click');
      // }
    }, 300);
  }
}
